import { render, staticRenderFns } from "./RemoveRuntimeLayerDialog.vue?vue&type=template&id=0f86b630"
import script from "./RemoveRuntimeLayerDialog.vue?vue&type=script&lang=js"
export * from "./RemoveRuntimeLayerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports